import PropTypes from "prop-types";
import { ReduceStore } from "flux/utils";
import Dispatcher from "Dispatcher";
import DefineActions from "jsmodel/DefineActions";
import typeCheckingStore from "data/util/typeCheckingStore";

function loadChoiceIntoState(state, def) {
    return {
        ...state,
        [def.key]: {
            key: def.key,
            atomic: def.options.some(o => o.atomic),
            options: def.options.map(o => ({
                id: o.id,
                name: o.name.toUpperCase(),
                label: o.label || o.name,
                atomic: o.atomic,
            })),
        },
    };
}

export const fromName = (options, name) => {
    if (name == null) {
        return null;
    }
    name = name.toUpperCase();
    return options.find(o => o.name === name);
};

export const fromId = (options, id) => {
    if (id == null) {
        return null;
    }
    return options.find(o => o.id === id);
};

export const fromNameOrId = (options, nameOrId) =>
    typeof nameOrId === "string"
        ? fromName(options, nameOrId)
        : fromId(options, nameOrId);

export class ChoiceStore extends ReduceStore {

    getInitialState() {
        return {};
    }

    reduce(state, action) {
        switch (action.type) {
            case DefineActions._UNLOAD:
                return this.getInitialState();
            case DefineActions.CHOICE:
                return loadChoiceIntoState(state, action.def);
            default:
                return state;
        }
    }

    getChoiceByKey(key) {
        const state = this.getState();
        if (!state.hasOwnProperty(key)) {
            throw new Error(`No '${key}' choice is known.`);
        }
        return state[key];
    }

    optionName(choiceKey) {
        const state = this.getState();
        const options = state[choiceKey].options;
        return id => {
            let opt = fromId(options, id);
            if (opt != null) {
                return opt.name;
            }
            // if the named choice doesn't have it, check all choices
            for (const k in state) {
                if (!state.hasOwnProperty(k)) continue;
                const otherOpts = state[k].options;
                opt = fromId(otherOpts, id);
                if (opt != null) {
                    // found the option
                    if (fromName(options, opt.name) != null) {
                        // the target choice has an equivalent option
                        return opt.name;
                    }
                    // stop looking
                    break;
                }
            }
            return null;
        };
    }

}

ChoiceStore.stateTypes = PropTypes.objectOf(
    PropTypes.shape({
        key: PropTypes.string.isRequired,
        atomic: PropTypes.bool.isRequired,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
                label: PropTypes.string.isRequired,
                atomic: PropTypes.bool, // missing is false-y
            }),
        ).isRequired,
    }),
);

export default typeCheckingStore(new ChoiceStore(Dispatcher));



// WEBPACK FOOTER //
// ./app/data/meta/ChoiceStore.js